'use client'
import { customFont } from "@/constants/project-specific";
import { extendVariants, Button, cn } from "@heroui/react";

export const ButtonOverride = extendVariants(Button, {
  variants: {
    // <- modify/add variants
    color: {

    },
    size: {
      sm: cn("[text-shadow:_1px_2px_0_rgb(0_0_0_/_0.9)]", customFont.className),
      lg: cn("[text-shadow:_2px_2px_0_rgb(0_0_0_/_0.4)]", customFont.className),
      md: cn("[text-shadow:_2px_2px_0_rgb(0_0_0_/_0.4)]", customFont.className),
    },
  },
});
